/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var VariableFuelSeaShippingMethod;
(function (VariableFuelSeaShippingMethod) {
    let vessel_type;
    (function (vessel_type) {
        vessel_type["SEA_OIL_TANKER_SMALL"] = "sea_oil_tanker_small";
        vessel_type["SEA_OIL_TANKER_MEDIUM"] = "sea_oil_tanker_medium";
        vessel_type["SEA_OIL_TANKER_LARGE"] = "sea_oil_tanker_large";
        vessel_type["SEA_GENERAL_CARGO_SMALL"] = "sea_general_cargo_small";
        vessel_type["SEA_GENERAL_CARGO_LARGE"] = "sea_general_cargo_large";
        vessel_type["SEA_BULK_CARRIER_SMALL"] = "sea_bulk_carrier_small";
        vessel_type["SEA_ROPAX"] = "sea_ropax";
    })(vessel_type = VariableFuelSeaShippingMethod.vessel_type || (VariableFuelSeaShippingMethod.vessel_type = {}));
    let fuel;
    (function (fuel) {
        fuel["HFO"] = "HFO";
        fuel["MGO"] = "MGO";
    })(fuel = VariableFuelSeaShippingMethod.fuel || (VariableFuelSeaShippingMethod.fuel = {}));
})(VariableFuelSeaShippingMethod || (VariableFuelSeaShippingMethod = {}));
//# sourceMappingURL=VariableFuelSeaShippingMethod.js.map